import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { fetchGraphQL } from './fetchGraphQL';

export const relayEnvironment = new Environment({
  network: Network.create(fetchGraphQL),
  store: new Store(new RecordSource()),
});
